import type { OrganizerGroupMessage } from '@pulsify/shared/dto'
import * as m from '~/paraglide/messages'

/** Messages in reading order, whichever way the page came. */
export function oldestFirst(messages: readonly OrganizerGroupMessage[]): OrganizerGroupMessage[] {
  return [...messages].sort((a, b) => a.createdAt.localeCompare(b.createdAt))
}

/** The sentence for a line like "Anna joined"; null for a message people wrote. */
export function systemLine(message: OrganizerGroupMessage): string | null {
  if (message.kind !== 'system') return null
  const actor = message.system?.actorName ?? m.groupsMemberGone()
  const target = message.system?.targetName ?? m.groupsMemberGone()
  switch (message.system?.kind) {
    case 'group_created':
      return m.groupsSystemCreated()
    case 'member_joined':
      return m.groupsSystemJoined({ name: target })
    case 'left_group':
      return m.groupsSystemLeft({ name: actor })
    case 'removed_participant':
      return m.groupsSystemRemoved({ name: target })
    default:
      return message.content ?? ''
  }
}
